import { IsAuthenticatedGuard } from "./services/auth/is-authenticated.guard";

const AUTH_GUARD_PROVIDERS = [
  IsAuthenticatedGuard
];

export {
  AUTH_GUARD_PROVIDERS
};
